import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import SimpleResponse from 'shared/api/model/SimpleResponse';
import createHttpRequest from 'shared/api/http';

export const passwordResetRequest =
    createAsyncThunk<SimpleResponse, string>('auth/passwordResetRequest', async(email) => {
        const response = await createHttpRequest({
            method: 'POST',
            path: ApiUrls.PASSWORD_RESET_REQUEST,
            errorMessage: t`Ошибка при запросе на сброс пароля`,
            data: {email},
            isAnonymous: true,
        });

        return response.data;
    });
